import React from 'react'
import { FilterSkeleton } from '../../dashboard/chart/CustomePieChart';
import { Box, MenuItem, Select, useTheme } from '@mui/material';
import { filterType } from '../../../redux-store/types/api-types';
import { CustomDropdownOrangeIcon } from '../../../assets/SvgIcons';
import { FilterComponentProps } from '../type';


function FilterDropDown(props: FilterComponentProps) {
    const { options, isLoading, defaultValue, handleChange } = props
    const theme = useTheme();

    return (

        isLoading ?
            <FilterSkeleton /> :
            <Box>
                <Select
                    defaultValue={defaultValue}
                    onChange={handleChange}
                    inputProps={{ 'aria-label': 'Filter selector' }}
                    sx={{
                        color: "#b5441c ",
                        fontWeight: 500,
                        fontSize: "16px",
                        fontFamily: `${theme.typography.fontFamily}`,
                        cursor: 'pointer',
                        padding: "7px 5px",
                        "& .MuiSelect-outlined": {
                            padding: "0px 7px",
                        },

                        "& .MuiSelect-select.MuiSelect-outlined.MuiInputBase-input.MuiOutlinedInput-input": {
                            paddingRight: "20px",
                        },

                        "&.Mui-focused": {
                            backgroundColor: "#E9F4FF",
                            outline: "2px solid #1E90FF",
                            outlineOffset: '2px',
                            "& .MuiOutlinedInput-notchedOutline": {
                                borderWidth: "0",
                                borderBottom: "1px dashed #A0AEC0",
                            },
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                            borderTop: 0,
                            borderLeft: 0,
                            borderRight: 0,
                            marginBottom: 0,
                            borderBottom: "1px dashed #A0AEC0",
                            borderRadius: 0,
                        },
                    }}
                    IconComponent={CustomDropdownOrangeIcon}
                    MenuProps={{
                        PaperProps: {
                            sx: {
                                padding: "0px 5px",
                                borderRadius: "12px",

                                "& .MuiMenuItem-root": {
                                    padding: "6px",
                                    borderRadius: "8px",
                                    fontWeight: 500,
                                    fontSize: "16px",
                                    fontFamily: `${theme.typography.fontFamily}`,
                                    color: "#b5441c ",
                                    my: 0.4,
                                    "&.Mui-selected": {
                                        backgroundColor: "",
                                        color: "#b5441c ",
                                    },
                                    "&.Mui-focusVisible": {
                                        backgroundColor: 'transparent',
                                        color: "#1E90FF",
                                        outline: "2px solid #1E90FF",
                                        outlineOffset: '-2px',
                                    },
                                },
                                "& .MuiMenuItem-root:hover": {
                                    backgroundColor: "",
                                    color: "#b5441c ",
                                },
                            },
                        },
                    }}
                >
                    {options?.map((data: filterType, key: number) => (
                        <MenuItem key={key as number} value={data.value}>{data.label}</MenuItem>
                    ))}
                </Select>
            </Box>


    );
}

export default FilterDropDown